export default __webpack_public_path__ + "static/media/598.39ef616f.png";